import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import delDialog from '@/components/System/DelDialog';
import NoData from '@/components/NoData/NoData';
export default {
  components: {
    SearchForm: SearchForm,
    delDialog: delDialog,
    NoData: NoData
  },
  data: function data() {
    return {
      searchFormData: [{
        title: '组织机构编号',
        key: 'sysName',
        placeholder: '请输入组织机构编号',
        type: 'input',
        selectData: [],
        selectedArr: [],
        value: ''
      }, {
        title: '组织机构名称',
        key: 'role',
        placeholder: '请输入组织机构名称',
        type: 'input',
        value: '',
        selectData: [],
        selectedArr: []
      }],
      btnType: 'search,reset',
      pageNum: 1,
      pageSize: 10,
      orgId: '',
      orgName: '',
      pageshow: true,
      defaultProps: {
        label: 'orgName',
        children: 'children',
        isLeaf: function isLeaf(data) {
          if (data.isChildren) {
            return false;
          } else {
            return false;
          }
        }
      },
      dataTree: [],
      selectdOrgArr: [],
      testArr: [],
      showRoleRelate: false,
      gridData: [],
      input: '',
      orgForm: {
        orgId: '',
        orgName: '',
        specialOrg: 'N',
        type: '',
        orgStatus: '',
        orgLabelCodeList: []
      },
      isEdit: false,
      addData: '',
      total: 0,
      orgRules: {
        orgId: [{
          required: true,
          message: '请输入组织机构编号',
          trigger: 'blur'
        }],
        orgName: [{
          required: true,
          message: '请输入组织机构名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择组织机构',
          trigger: 'change'
        }]
      },
      childOrg: false,
      ifShowDelDialog: false,
      visible: false,
      delData: '',
      nodeData: '',
      isEditDel: false,
      popoverOrgId: '',
      specialorglist: [{
        orgId: 'N',
        orgName: '否'
      }],
      showpopconfirm: true,
      loading: false,
      isSpecial: false,
      orgTypeObj: JSON.parse(sessionStorage.getItem('dist_info')),
      orgTypeList: [],
      operateList: [],
      orgLabelList: []
    };
  },
  methods: {
    dialogCancel: function dialogCancel() {
      this.showRoleRelate = false;
      this.orgForm.type = null;
    },
    closeOperate: function closeOperate() {
      this.$refs[this.popoverOrgId].doClose();
    },
    getOrgNameSub: function getOrgNameSub(val) {
      if (val.substr(-2, 2) === '分行') {
        this.orgForm.type = 'FIRST_BRANCH';
      } else if (val.substr(-2, 2) === '支行') {
        this.orgForm.type = 'FIRST_SUB_BRANCH';
      }
    },
    sortResource: function sortResource(data, order) {
      var _this = this;
      this.$refs[data.orgId].doClose();
      this.operateList = [];
      this.operateList.push(data.parentId);
      this.operateList.push(data.branch);
      var direction;
      if (order === 'up') {
        direction = 'UP';
      } else {
        direction = 'DOWN';
      }
      this.$API.postRequest({
        url: '/platform/org/sortResource',
        data: {
          orgId: data.orgId,
          parentId: data.parentId,
          direction: direction
        }
      }).then(function () {
        _this.getInit();
      });
    },
    popverClick: function popverClick(showOrgId) {
      var t = showOrgId + 1;
      this.$refs[t].doClose();
    },
    popverContentClick: function popverContentClick() {
      if (this.popoverOrgId) {
        this.$refs[this.popoverOrgId].doClose();
      }
    },
    showPopover: function showPopover(Id) {
      // this.showpopconfirm = true
      if (this.popoverOrgId && this.popoverOrgId === Id) {
        this.$refs[Id].doShow();
      } else if (this.popoverOrgId) {
        this.$refs[this.popoverOrgId].doClose();
        this.$refs[Id].doShow();
      } else {
        this.$refs[Id].doShow();
      }
      this.popoverOrgId = Id;
    },
    delOrgBtn: function delOrgBtn() {
      if (this.selectdOrgArr.length > 0) {
        this.ifShowDelDialog = true;
        this.isEditDel = false;
      }
    },
    delRole: function delRole() {
      var _this2 = this;
      var data = [];
      this.selectdOrgArr.forEach(function (ele) {
        data.push(ele.orgId);
      });
      this.$API.delRequest({
        url: '/platform/org',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.$message({
            message: '删除成功',
            type: 'success'
          });
          if (_this2.pageNum === Math.ceil(_this2.total / _this2.pageSize) && (_this2.total % _this2.pageSize === _this2.selectdOrgArr.length || _this2.total % _this2.pageSize === 0)) {
            _this2.pageNum > 1 ? _this2.pageNum-- : _this2.pageNum = 1;
          }
          _this2.ifShowDelDialog = false;
          _this2.getInit();
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNum = val;
      if (this.orgId === '' && this.orgName === '') {
        this.getInit();
      } else {
        this.getOrgByOrg();
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      if (this.orgId === '' && this.orgName === '') {
        this.getInit();
      } else {
        this.getOrgByOrg();
      }
    },
    addChildrenOrg: function addChildrenOrg(node, data) {
      this.operateList = [];
      this.operateList.push(data.parentId);
      this.operateList.push(data.branch);
      this.addData = data;
      this.childOrg = true;
      this.isEdit = false;
      this.orgForm.orgId = '';
      this.orgForm.orgName = '';
      this.orgForm.orgLabelCodeList = [];
      this.$refs[data.orgId].doClose();
      this.orgForm.specialOrg = data.specialOrg;
      if (data.specialOrg === 'N') {
        this.isSpecial = false;
      } else {
        this.isSpecial = true;
      }
      this.showRoleRelate = true;
      this.getSpecialOrg();
    },
    editorgDelete: function editorgDelete(node, data) {
      this.delData = '';
      this.nodeData = '';
      this.nodeData = node;
      this.delData = data;
      this.isEditDel = true;
      this.editDel();
      // this.ifShowDelDialog = true
    },
    confirmdelmanage: function confirmdelmanage(node, data, bool) {
      this.operateList = [];
      this.operateList.push(data.parent);
      this.operateList.push(data.branch);
      var t = data.orgId + 1;
      this.$refs[t].doClose();
      this.popoverOrgId = '';
      if (bool) {
        this.$refs[data.orgId].doClose();
        this.editorgDelete(node, data);
      }
    },
    getTotal: function getTotal() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$API.getRequest({
                  url: '/platform/org/firstOrgs',
                  data: {
                    pageNum: _this3.pageNum,
                    pageSize: _this3.pageSize
                  }
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    _this3.total = res.result.total;
                  }
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    editDel: function editDel() {
      var _this4 = this;
      var orgIdArr = [];
      orgIdArr.push(this.delData.orgId);
      this.$API.delRequest({
        url: '/platform/org',
        data: orgIdArr
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.searchFormData[0].value = '';
          _this4.searchFormData[1].value = '';
          _this4.ifShowDelDialog = false;
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });
          // let page = Math.ceil(this.total/this.pageSize)  // 最大页数
          // if(this.pageNum == page){
          //   if(this.total%this.pageSize == 1) {
          //     this.pageNum > 1 ? this.pageNum-- : this.pageNum = 1
          //     this.getInit()
          //     // this.$refs.tree.remove(this.nodeData)
          //     return
          //   }
          // }
          _this4.$refs.tree.remove(_this4.nodeData);
          _this4.getTotal();
        }
      });
    },
    addOrg: function addOrg() {
      var _this5 = this;
      var child = this.childOrg;
      this.$API.postRequest({
        url: '/platform/org',
        data: {
          orgId: this.orgForm.orgId,
          orgName: this.orgForm.orgName,
          type: this.orgForm.type,
          orgLabel: this.orgForm.orgLabel,
          specialOrg: this.orgForm.specialOrg,
          pathId: child ? "".concat(this.addData.pathId, "/").concat(this.orgForm.orgId) : this.orgForm.orgId,
          pathName: child ? "".concat(this.addData.pathName, "/").concat(this.orgForm.orgName) : this.orgForm.orgName,
          depth: child ? this.addData.depth + 1 : 1,
          branch: child ? this.addData.branch : this.orgForm.orgId,
          parentId: child ? this.addData.orgId : null
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.orgForm.type = null;
          _this5.showRoleRelate = false;
          _this5.pageshow = false;
          //  this.getInit()
          _this5.getResult(child);
          _this5.$nextTick(function () {
            _this5.pageshow = true;
          });
        }
      });
    },
    getResult: function getResult(child) {
      // sonar 复杂度出力 返回后数据移出
      this.$message({
        message: child ? '新增子机构成功' : '新增机构成功',
        type: 'success'
      });
      if (!child) {
        this.pageNum = this.total % this.pageSize === 0 ? Math.ceil(this.total / this.pageSize) + 1 : Math.ceil(this.total / this.pageSize);
      }
      if (this.orgId === '' && this.orgName === '') {
        this.getInit();
      } else {
        this.getOrgByOrg();
      }
    },
    addEditOrg: function addEditOrg() {
      var _this6 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (!_this6.isEdit) {
            _this6.addOrg();
          } else {
            var data = {};
            // eslint-disable-next-line guard-for-in
            for (var i in _this6.orgForm) {
              data[i] = _this6.orgForm[i];
            }
            var path = _this6.addData.pathName.split('/');
            path[path.length - 1] = _this6.orgForm.orgName;
            _this6.addData.pathName = path.join('/');
            data.pathName = _this6.addData.depth > 1 ? _this6.addData.pathName : _this6.orgForm.orgName;
            data.parentId = _this6.addData.parentId;
            _this6.$API.putRequest({
              url: '/platform/org',
              data: data
            }).then(function (res) {
              if (res.code === '0000000000') {
                _this6.orgForm.type = null;
                _this6.editResult();
              }
            });
          }
          _this6.isSpecial = false;
        } else {
          _this6.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
      this.isSpecial = false;
    },
    editResult: function editResult() {
      // sonar 复杂度处理返回后数据编辑移出
      this.$message({
        message: '编辑成功',
        type: 'success'
      });
      this.showRoleRelate = false;
      // this.getInit()
      if (this.orgId === '' && this.orgName === '') {
        this.getInit();
      } else {
        this.getOrgByOrg();
      }
    },
    // 获取特殊机构
    getSpecialOrg: function getSpecialOrg() {
      var _this7 = this;
      this.specialorglist = [{
        orgId: 'N',
        orgName: '否'
      }];
      this.$API.getRequest({
        url: '/platform/org/special'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this7.specialorglist = _this7.specialorglist.concat(res.result);
        }
      });
    },
    editRoleDialog: function editRoleDialog(node, data) {
      this.operateList = [];
      this.operateList.push(data.parentId);
      this.operateList.push(data.branch);
      this.addData = data;
      this.isEdit = true;
      this.orgForm.orgId = data.orgId;
      this.orgForm.id = data.id;
      this.orgForm.orgName = data.orgName;
      this.orgForm.type = data.type;
      this.orgForm.orgLabelCodeList = data.orgLabelCodeList;
      this.$refs[data.orgId].doClose();
      this.orgForm.specialOrg = data.specialOrg;
      this.orgForm.orgStatus = data.orgStatus;
      this.showRoleRelate = true;
      this.getSpecialOrg();
    },
    loadNode: function loadNode(node, resolve) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var checked;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(node.level === 0)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", resolve(_this8.dataTree));
              case 4:
                checked = false;
                if (_this8.selectdOrgArr.length > 0) {
                  _this8.selectdOrgArr.forEach(function (element) {
                    if (element.pathId.indexOf(node.pathId)) {
                      checked = true;
                    }
                  });
                }
                _context2.next = 8;
                return _this8.getTreeList({
                  depth: node.data.depth + 1,
                  orgId: node.data.orgId,
                  isChecked: checked
                });
              case 8:
                resolve(JSON.parse(JSON.stringify(_this8.testArr)));
                // this.setCheckedStatus(JSON.parse(JSON.stringify(this.testArr)))
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getInit: function getInit() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this9.loading = true;
                _this9.dataTree = [];
                _context3.next = 4;
                return _this9.$API.getRequest({
                  url: '/platform/org/firstOrgs',
                  data: {
                    pageNum: _this9.pageNum,
                    pageSize: _this9.pageSize
                  }
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    _this9.loading = false;
                    _this9.dataTree = res.result.records;
                    _this9.total = res.result.total;
                  }
                });
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getOrgByOrg: function getOrgByOrg() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this10.dataTree = [];
                _context4.next = 3;
                return _this10.$API.getRequest({
                  url: '/platform/org/getOrgByOrgIdOrOrgName',
                  data: {
                    orgId: _this10.orgId,
                    orgName: _this10.orgName,
                    pageNum: _this10.pageNum,
                    pageSize: _this10.pageSize
                  }
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    _this10.dataTree = res.result.records;
                    _this10.total = res.result.total;
                  }
                });
              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getTreeList: function getTreeList(item) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // let id = item.orgId;
                // if (item.orgId && item.orgId.length > 6) {
                //   const idArr = item.orgId.split('/');
                //   id = idArr[idArr.length - 1];
                // }
                params = {
                  orgId: item.orgId
                };
                _context5.next = 3;
                return _this11.$API.getRequest({
                  url: '/platform/org/getChildOrg',
                  data: params
                }).then(function (res) {
                  if (!item.orgId) {
                    _this11.dataTree = res.result;
                  } else {
                    _this11.testArr = res.result;
                    _this11.requestOver = true;
                  }
                  if (item.depth === 1) {
                    // 显示所有数组
                    if (_this11.selectdOrgArr.length > 0) {
                      // 表示页面有默认选中值
                      setTimeout(function () {
                        _this11.setSelectedStatus(res.result);
                      }, 0);
                    }
                  }
                });
              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleCheckChange: function handleCheckChange(data, checkObj) {
      var checked = false;
      checkObj.checkedKeys.forEach(function (element) {
        if (element === data.pathId) {
          checked = true;
        }
      });
      // const data1=[
      // ...this.$refs.tree.getHalfCheckedKeys(),
      // ...this.$refs.tree.getCheckedKeys()
      // ]
      // console.log("ddddddd", this.$refs.tree.getCheckedKeys())
      // let arr = data.pathId.split('/')
      var str = this.getPathid(data.pathId);
      var parNode = this.$refs.tree.getNode(str);
      if (checked) {
        // 全选
        if (data.depth > 1) {
          var newParthId = this.chooceTopJudge(str);
          if (parNode.checked) {
            this.selectdOrgArr = this.selectdOrgArr.filter(function (item) {
              return item.pathId.indexOf(newParthId) === -1;
            });
            var newNode = this.$refs.tree.getNode(newParthId);
            this.selectdOrgArr.push(newNode.data);
          } else {
            this.selectdOrgArr.push(data);
          }
        } else {
          this.selectdOrgArr.push(data);
        }
      } else {
        // 取消
        this.noCheckAll(data, checkObj, str);
      }
    },
    getPathid: function getPathid(pathId) {
      // 获取父id
      var str = '';
      var arr = pathId.split('/');
      for (var i = 0; i < arr.length - 1; i++) {
        str += "".concat(arr[i], "/");
      }
      str = str.substr(0, str.length - 1);
      return str;
    },
    noCheckAll: function noCheckAll(data, checkObj, str) {
      var _this12 = this;
      // 非全选
      if (data.depth > 1) {
        // 判断是否是上一次是全选
        var halfArr = checkObj.halfCheckedKeys;
        var topId = str.substr(0, 6); // 获取下面
        var newArr = checkObj.checkedNodes.filter(function (item) {
          return item.pathId.indexOf(topId) > -1;
        });
        var ohterArr = this.selectdOrgArr.filter(function (item) {
          return item.depth > data.depth && item.indexOf(topId) > -1;
        }); // 获取更深层级的选中
        this.selectdOrgArr = this.selectdOrgArr.filter(function (item) {
          return item.pathId.indexOf(topId) < 0;
        });
        this.selectdOrgArr = this.selectdOrgArr.concat(newArr);
        if (ohterArr.length > 0) {
          this.selectdOrgArr = this.selectdOrgArr.concat(ohterArr);
        }
        var repeatArr = [];
        halfArr.forEach(function (element) {
          _this12.selectdOrgArr.forEach(function (sub) {
            if (element === sub.pathId) {
              repeatArr.push(element);
            }
          });
        });
        if (repeatArr.length > 0) {
          repeatArr.forEach(function (element) {
            _this12.selectdOrgArr = _this12.selectdOrgArr.filter(function (item) {
              return item.pathId !== element;
            });
          });
        }
      } else {
        this.selectdOrgArr = this.selectdOrgArr.filter(function (item) {
          return item.pathId.indexOf(data.pathId) < 0;
        });
      }
    },
    chooceTopJudge: function chooceTopJudge(pathId) {
      // 判断是否触发上一级
      var newPathId = pathId;
      var parentNode = this.$refs.tree.getNode(pathId);
      var bool = parentNode.checked;
      while (bool) {
        if (newPathId.length === 6) {
          bool = false;
        } else {
          var newId = this.getPathid(newPathId);
          parentNode = this.$refs.tree.getNode(newId);
          bool = parentNode.checked;
          if (bool) {
            newPathId = newId;
          }
        }
      }
      return newPathId;
    },
    setCheckedStatus: function setCheckedStatus(arr) {
      var _this13 = this;
      if (arr.length === 0) return;
      // if(allCheckedArr.length > 0) { // 设置全选
      this.selectdOrgArr.forEach(function (element) {
        arr.forEach(function (sub) {
          if (element.pathId === sub.pathId) {
            _this13.$refs.tree.setChecked(element.pathId, true);
          } else if (element.pathId.indexOf(sub.pathId) > -1) {
            var parNode = _this13.$refs.tree.getNode(sub.pathId);
            parNode.indeterminate = true;
          }
        });
      });
      // }else {
      //   halfCheckedArr.forEach(element => {
      //     arr.forEach(sub => {
      //       if(element.pathId) {

      //       }
      //     })
      //   })
      // }

      // this.selectdOrgArr
    },
    exportTable: function exportTable() {},
    addTable: function addTable() {
      this.isEdit = false;
      this.childOrg = false;
      this.orgForm.orgId = '';
      this.orgForm.orgName = '';
      this.orgForm.specialOrg = 'N';
      this.orgForm.type = '';
      this.showRoleRelate = true;
      this.getSpecialOrg();
    },
    searchForm: function searchForm(item) {
      this.pageNum = 1;
      if (item[0].value === '' && item[1].value === '') {
        this.orgId = '';
        this.orgName = '';
        this.getInit();
      } else {
        this.orgId = item[0].value;
        this.orgName = item[1].value;
        this.getOrgByOrg();
      }
    },
    resetForm: function resetForm() {
      this.searchFormData[0].value = '';
      this.searchFormData[1].value = '';
      this.orgId = '';
      this.orgName = '';
      this.pageNum = 1;
      this.getInit();
      this.getpermissionlist();
    } // changesearch(obj){
    //   console.log(obj,"pppppppppppppppppp")
    //   this.orgId = obj[0].value
    //   this.orgName = obj[1].value
    // },
  },
  created: function created() {
    // eslint-disable-next-line guard-for-in
    for (var i in this.orgTypeObj.ORG_TYPE) {
      this.orgTypeList.push({
        key: i,
        value: this.orgTypeObj.ORG_TYPE[i]
      });
    }
    // eslint-disable-next-line guard-for-in
    for (var _i in this.orgTypeObj.ORG_LABEL) {
      this.orgLabelList.push({
        key: _i,
        value: this.orgTypeObj.ORG_LABEL[_i]
      });
    }
    this.getInit();
  }
};